module.exports = __webpack_public_path__ + "e6ede9677685b1ec74c5a84946e0e365.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/phone-icon.png
// module id = 816
// module chunks = 0